module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9r2r5r-0ff3592279e743a6b47f8d42b7108400.svg";